module.exports = __webpack_public_path__ + "static/media/synagogue.165f4846.svg";